import { render, staticRenderFns } from "./TableHeading.vue?vue&type=template&id=a3302b7e"
import script from "./TableHeading.vue?vue&type=script&lang=js"
export * from "./TableHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports